const getNestedObject = (object: any, path: string[]) => {
  if (!Array.isArray(path)) throw Error('path must be an array');
  return path.reduce(
    (obj, key) => (obj && obj[key] !== 'undefined' ? obj[key] : undefined),
    object
  );
};
export default getNestedObject;
